<template>
    <h3 class="imarcGreeting__meta">
        {{ dateTime }}
    </h3>
</template>

<script>
import moment from 'moment';

export default {
    name: 'TimeDate',
    data() {
        return {
            dateTime: moment().format('h:mm a dddd, MMMM Do, YYYY'),
        };
    },
    mounted() {
        setInterval(() => {
            this.dateTime = moment().format('h:mm a dddd, MMMM Do, YYYY');
        }, 10000);
    },
};
</script>
